<template>
  <v-container fluid full-height grid-list-md>
    <v-layout row wrap>
      <v-flex xs12>
        <div class="text-xs-left">
          <v-breadcrumbs :items="breadcrumbs" divider=">"></v-breadcrumbs>
        </div>
      </v-flex>
      <v-flex xs12>
        <v-layout row wrap>
          <v-flex sm4>
            <v-menu
              :nudge-right="40"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              min-width="290px"
            >
              <v-text-field
                slot="activator"
                v-model="queryParams.fromDate"
                label="From Date"
                prepend-icon="event"
                readonly
              ></v-text-field>
              <v-date-picker v-model="queryParams.fromDate"></v-date-picker>
            </v-menu>
          </v-flex>
          <v-flex sm4>
            <v-menu
              :nudge-right="40"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              min-width="290px"
            >
              <v-text-field
                slot="activator"
                v-model="queryParams.toDate"
                label="To Date"
                prepend-icon="event"
                readonly
              ></v-text-field>
              <v-date-picker v-model="queryParams.toDate"></v-date-picker>
            </v-menu>
          </v-flex>
          <v-flex sm4>
            <v-text-field
              name="saleNo"
              label="Product Name"
              v-model="queryParams.menuName"
              type="text"
            ></v-text-field>
          </v-flex>
          <v-flex sm4>
            <v-text-field
              name="productCode"
              label="Code"
              v-model="queryParams.productCode"
              type="text"
            ></v-text-field>
          </v-flex>
          <v-flex sm4>
            <v-select
              :items="shopList"
              label="Choose Shop..."
              item-text="name"
              menu-props="auto"
              item-value="id"
              v-model="queryParams.shopId"
            ></v-select>
          </v-flex>
          <v-flex sm4>
            <v-select
              :items="categoryList"
              label="Choose Category..."
              item-text="name"
              menu-props="auto"
              item-value="id"
              v-model="queryParams.categoryId"
              type="text"
            ></v-select>
          </v-flex>
          <v-flex sm4>
            <v-select
              :items="brandList"
              label="Choose Brand..."
              item-text="name"
              menu-props="auto"
              item-value="id"
              v-model="queryParams.brandId"
            ></v-select>
          </v-flex>
          <v-flex sm4>
            <v-select
              :items="productGroupList"
              label="Choose Product Group..."
              item-text="name"
              menu-props="auto"
              item-value="id"
              v-model="queryParams.productGroupId"
            ></v-select>
          </v-flex>
          <v-flex sm4>
            <v-select
              :items="saleTypeList"
              label="Choose Sale Type..."
              v-model="queryParams.saleType"
              item-text="label"
              item-value="value"
            ></v-select>
          </v-flex>
          <v-flex sm4>
            <v-autocomplete 
              v-model="queryParams.currencyId"
              :items="currencyList"
              color="blue-grey lighten-2"
              label="Choose Currency..."
              @change="getCurrencyCode"
              item-text="code"
              menu-props="auto"
              item-value="id"
            ></v-autocomplete>
          </v-flex>
          <v-flex sm4>
            <v-btn outline color="primary" @click="onSearch">
              Search
              <v-icon right>search</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex xs12>
        <v-card>
          <v-card-title class="blue darken-3">
            <span class="headline white--text">Summary</span>
          </v-card-title>
          <v-card-text class="font-weight-bold">
            <div>
              <span>Total Retail Sale Amount:</span>
              <v-chip>
                <span>{{ totalRetailSaleAmount | decFormat }}</span>
              </v-chip>

              <span>Total Retail Sale FOC Amount:</span>
              <v-chip>
                <span>{{ totalRetailSaleFocAmount | decFormat }}</span>
              </v-chip>
            </div>
            <div>
              <span>Total Whole Sale Amount:</span>
              <v-chip>
                <span>{{ totalWholeSaleAmount | decFormat }}</span>
              </v-chip>

              <span>Total Whole Sale FOC Amount:</span>
              <v-chip>
                <span>{{ totalWholeSaleFocAmount | decFormat}}</span>
              </v-chip>

              <span>Currency:</span>
              <v-chip>
                <span>{{ currencyCode }}</span>
              </v-chip>
            </div>
            <div>
              <v-btn
                :loading="buttonLoading"
                color="primary"
                @click="printAllMenu('printMenu')"
              >PRINT ALL</v-btn>
              <v-btn
                :loading="buttonLoading"
                color="success"
                @click="exportAllMenuReport()"
              >EXPORT ALL</v-btn>
            </div>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs12 class="mt-1">
        <v-card>
          <v-data-table
            :must-sort="true"
            :headers="headers"
            :items="menuReportList"
            class="elevation-1"
            :loading="showListLoading"
            :total-items="totalRows"
            :rows-per-page-items="rowsPerPageItems"
            :pagination.sync="pagination"
          >
            <template slot="items" slot-scope="props">
              <td>{{ props.item.shopName }}</td>
              <td>{{ props.item.saleType }}</td>
              <td>{{ props.item.productName }}</td>
              <td>{{ props.item.productCode }}/{{ props.item.brandName }}/{{ props.item.productGroupName }}/{{ props.item.categoryName }}</td>
              <td>{{ props.item.factorUnitName }}</td>
              <td>{{ props.item.unitPrice | decFormat }}</td>
              <td>{{ props.item.focQty }}</td>
              <td>{{ props.item.focAmount | decFormat }}</td>
              <td>{{ props.item.saleQty }}</td>
              <td>{{ props.item.saleAmount | decFormat }}</td>
              <td>
                <v-btn color="primary" @click.stop="showDetailDialog(props.item)">DETAIL</v-btn>
              </td>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>
    <!-- <summary report> -->
    <div id="printMenu" style="bsale:1px solid black;width:300px;" v-show="false">
      <div style="text-align:center">
        <p style="font-size:18px;margin:1px">Product Item Summary</p>
      </div>
      <div style="text-align:center">
        <p
          style="font-size:15px;margin:1px"
        >From: [{{queryParams.fromDate}}] To: [{{queryParams.toDate}}]</p>
      </div>
      <div style="text-align:left">
        <p
          style="font-size:15px;margin:0px"
        >Total Retail Sale Amount: {{totalRetailSaleAmount | decFormat}}</p>
      </div>
      <div style="text-align:left">
        <p
          style="font-size:15px;margin:0px"
        >Total Retail Sale FOC Amount: {{totalRetailSaleFocAmount | decFormat}}</p>
      </div>
      <div style="text-align:left">
        <p
          style="font-size:15px;margin:0px"
        >Total Whole Sale Amount: {{totalWholeSaleAmount | decFormat}}</p>
      </div>
      <div style="text-align:left">
        <p
          style="font-size:15px;margin:0px"
        >Total Whole Sale FOC Amount: {{totalWholeSaleFocAmount | decFormat}}</p>
      </div>
      <div style="text-align:left">
        <p
          style="font-size:15px;margin:0px"
        >Currency: {{ currencyCode }}</p>
      </div>
      <br />
      <div style="padding-left:5px;padding-right:5px">
        <table
          style="font-family: arial, sans-serif;border-collapse: collapse;width: 100%;font-size:11px;border-top:1px solid black"
        >
          <thead style="border-bottom:1px solid black;border-top:1px solid black">
            <tr>
              <th style="text-align:left">Shop Name</th>
              <th style="text-align:left">Sale Type</th>
              <th style="text-align:left">Product Name</th>
              <th style="text-align:left">Code/Brand/Group/Cat.</th>
              <th style="text-align:left">Unit</th>
              <th style="text-align:left">Price</th>
              <th style="text-align:left">FOC</th>
              <th style="text-align:left">FOC Amt</th>
              <th style="text-align:left">Sale</th>
              <th style="text-align:left">Sale Amt</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in allMenuReportList" :key="index">
              <td style="text-align:left">{{item.shopName}}</td>
              <td style="text-align:left">{{item.saleType}}</td>
              <td style="text-align:left">{{item.productName}}</td>
              <td style="text-align:left">{{item.productCode}}/{{item.brandName}}/{{item.productGroupName}}/{{item.categoryName}}</td>
              <td style="text-align:left">{{item.factorUnitName}}</td>
              <td style="text-align:left">{{item.unitPrice | decFormat}}</td>
              <td style="text-align:left">{{item.focQty }}</td>
              <td style="text-align:left">{{item.focAmount | decFormat }}</td>
              <td style="text-align:left">{{item.saleQty }}</td>
              <td style="text-align:left">{{item.saleAmount | decFormat }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!--product sale report detail dialog -->
    <v-dialog v-model="detailDialogFlag" scrollable max-width="1000px">
      <v-card>
        <v-card-title>
          <!-- Search Section -->
          <v-layout wrap>
            <v-flex sm4>
              <v-menu
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
              <v-text-field
                slot="activator"
                v-model="detailQueryParams.fromDate"
                label="From Date"
                prepend-icon="event"
                readonly
              ></v-text-field>
              <v-date-picker v-model="detailQueryParams.fromDate" :min="queryParams.fromDate" :max="queryParams.toDate"></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex sm4>
              <v-menu
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
              <v-text-field
                slot="activator"
                v-model="detailQueryParams.toDate"
                label="To Date"
                prepend-icon="event"
                readonly
              ></v-text-field>
              <v-date-picker v-model="detailQueryParams.toDate" :min="queryParams.fromDate" :max="queryParams.toDate"></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex sm4>
              <v-text-field 
                name="issueNo" 
                label="Issue No" 
                v-model="detailQueryParams.issueNo" 
                type="text"
                class="ml-2"
              ></v-text-field>
            </v-flex>
            <v-flex sm4>
              <v-btn outline color="primary" @click="detailSearch()">
                Search
                <v-icon right>search</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-flex xs12>
            <v-card>
              <v-card-text class="font-weight-bold">
                <div>
                  <span class="ml-3">Product Code:</span>
                  <v-chip>
                    <span>{{ productCode }}</span>
                  </v-chip>

                  <span>Product Name:</span>
                  <v-chip>
                    <span>{{ productName }}</span>
                  </v-chip>

                  <span>Total Sale Qty:</span>
                  <v-chip>
                    <span>{{ totalSaleQty | decFormat }}</span>
                  </v-chip>

                  <span>Total Sale Amount:</span>
                  <v-chip>
                    <span>{{ totalSaleAmount | decFormat }}</span>
                  </v-chip>
                </div>
              </v-card-text>
            </v-card>
          </v-flex>
          <v-flex xs12 class="mt-1">
            <v-card>
              <v-data-table
                :headers="detailHeaders"
                :items="menuReportDetailList"
                class="elevation-1"
                :loading="showListLoading"
                :total-items="detailTotalRow"
                :rows-per-page-items="rowsPerPageItems"
                :pagination.sync="detailPagination"
                :must-sort="true"
              >
                <template slot="items" slot-scope="props">
                  <td>{{ props.item.saleDateInMilliSeconds | format-ms-date-time }}</td>
                  <td>{{ props.item.issueNo }}</td>
                  <td>{{ props.item.factorUnitName }}</td>
                  <td>{{ props.item.unitPrice | decFormat}}</td>
                  <td>{{ props.item.focQty }}</td>
                  <td>{{ props.item.focAmount | decFormat }}</td>
                  <td>{{ props.item.saleQty }}</td>
                  <td>{{ props.item.saleAmount | decFormat }}</td>
                </template>
              </v-data-table>
            </v-card>
          </v-flex>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { commonService } from "../../services/common-service";
import { menuReportService } from "../../services/menu-report-service";
import { shopService } from "../../services/shop-service";
import { categoryService } from "../../services/category-service";
import { brandService } from "../../services/brand-service";
import { productGroupService } from "../../services/product-group-service";
import { currencyService } from "../../services/currency-service";

export default {
  name: "MenuReportList",

  components: {},
  data: () => ({
    showListLoading: false,
    detailDialogFlag: false,
    shopList: [],
    categoryList: [],
    brandList: [],
    productGroupList: [],
    allMenuReportList: [],
    breadcrumbs: [
      {
        text: "Reports",
        disabled: true
      },
      {
        text: "Product Sale Report",
        disabled: true
      }
    ],
    headers: [
      { text: "Shop Name", align: "left", value: "t.shopName" },
      { text: "Sale Type", align: "left", sortable: false },
      { text: "Product Name", align: "left", value: "t.productName" },
      { text: "Code/Brand/Group/Cat.", align: "left", sortable: false},
      { text: "Unit", align: "left", sortable: false },
      { text: "Price", value: "t.unitPrice" },
      { text: "FOC", sortable: false },
      { text: "FOC Amt", sortable: false },
      { text: "Sale", sortable: false },
      { text: "Sale Amt", sortable: false },
      { text: "Action", sortable: false, align: "center" }
    ],
    detailHeaders: [
      { text: "Date", sortable: false },
      { text: "Issue No", sortable: false },
      { text: "Unit", sortable: false },
      { text: "Price", sortable: false },
      { text: "FOC", sortable: false },
      { text: "FOC Amt", sortable: false },
      { text: "Sale", sortable: false },
      { text: "Sale Amt", sortable: false },
    ],
    saleTypeList: [
      { label: "---All---", value: "" },
      { label: "Retail Sale", value: "RETAIL SALE" },
      { label: "Whole Sale", value: "WHOLE SALE" }
    ],
    rowsPerPageItems: [25, 50, 100],
    pagination: {
      descending: false,
      page: 1,
      sortBy: "t.productName",
      rowsPerPage: 50,
      totalItems: 0
    },
    detailPagination: {
      descending: false,
      page: 1,
      rowsPerPage: 50,
      totalItems: 0
    },
    menuReportList: [],
    totalRows: 0,
    detailTotalRow: 0,
    queryParams: {
      fromDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
      toDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
      menuName: "",
      categoryId: "",
      shopId: "",
      productCode: "",
      brandId: "",
      productGroupId: "",
      saleType: "",
      currencyId: ""
    },
    detailQueryParams: {
      fromDate: "",
      toDate: "",
      issueNo: "",
      saleType: "",
      shopName: "",
      productCode: "",
      factorUnitName: "",
      unitPrice: ""
    },
    clonequeryParams: new Object(),
    buttonLoading: false,
    totalRetailSaleAmount: 0,
    totalRetailSaleFocAmount: 0,
    totalWholeSaleAmount: 0,
    totalWholeSaleFocAmount: 0,
    currencyCode : "",
    productCode: "",
    productName: "",
    totalSaleQty: 0,
    totalSaleAmount: 0.0,
    menuReportDetailList: [],
    currencyList: []
  }),
  watch: {
    pagination: {
      handler() {
        this.getMenuReportList();
        this.getMenuReportSummary();
      },
      deep: true
    }
  },
  created() {
    //for deep linking
    if (this.$route.query.shopId) {
      this.queryParams.shopId = this.$route.query.shopId;
    }
    if (this.$route.query.categoryId) {
      this.queryParams.categoryId = this.$route.query.categoryId;
    }
    if (this.$route.query.menuName) {
      this.queryParams.menuName = this.$route.query.menuName;
    }
    if (this.$route.query.productCode) {
      this.queryParams.productCode = this.$route.query.productCode;
    }
    if (this.$route.query.fromDate) {
      this.queryParams.fromDate = this.$route.query.fromDate;
    }
    if (this.$route.query.toDate) {
      this.queryParams.toDate = this.$route.query.toDate;
    }

    if (this.$route.query.brandId) {
      this.queryParams.brandId = this.$route.query.brandId;
    }

    if (this.$route.query.productGroupId) {
      this.queryParams.productGroupId = this.$route.query.productGroupId;
    }

    if (this.$route.query.saleType) {
      this.queryParams.saleType = this.$route.query.saleType;
    }

    if (this.$route.query.page) {
      this.pagination.page = this.$route.query.page;
    }
    if (this.$route.query.size) {
      this.pagination.size = this.$route.query.size;
    }
    this.getAllShop();
    this.getAllCategory();
    this.getAllBrand();
    this.getAllProductGroup();
    this.getActiveCurrency()
    .finally(()=>{
      this.onSearch();
    });
  },
  methods: {
    onSearch() {
      this.queryParams.page = this.pagination.page;
      this.queryParams.size = this.pagination.rowsPerPage;
      this.$router.replace({ name: "menu-report", query: this.queryParams });
      this.getMenuReportList();
      this.getMenuReportSummary();
      this.clonequeryParams = Object.assign({}, this.queryParams);
    },

    exportAllMenuReport() {
      this.buttonLoading = true;
      menuReportService
        .exportMenuReportExcel(this.clonequeryParams)
        .then(res => {
          commonService.downloadE(res);
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          this.buttonLoading = false;
        });
    },

    getAllShop() {
      shopService
        .getAllShop()
        .then(res => {
          this.shopList = res.data;
          let findAll = {
            id: "",
            name: "----All----"
          };
          this.shopList.splice(0, 0, JSON.parse(JSON.stringify(findAll)));
        })
        .catch(err => {
          console.log(err);
        });
    },

    getCurrencyCode(){
          let c = commonService.search("id",this.queryParams.currencyId,this.currencyList);
          if(c){
            this.currencyCode = c.code;
          }
    },

    getAllCategory() {
      categoryService
        .getAllCategory()
        .then(res => {
          this.categoryList = res.data;
          let findAll = {
            id: "",
            name: "----All----"
          };
          this.categoryList.splice(0, 0, JSON.parse(JSON.stringify(findAll)));
        })
        .catch(err => {
          console.log(err);
        });
    },

    getAllBrand() {
      brandService
        .getAllBrand()
        .then(res => {
          this.brandList = res.data;
          let findAll = {
            id: "",
            name: "---All---"
          };
          this.brandList.splice(0, 0, JSON.parse(JSON.stringify(findAll)));
        })
        .catch(err => console.log(err));
    },

    getAllProductGroup() {
      productGroupService
        .getAllProductGroup()
        .then(res => {
          this.productGroupList = res.data;
          let findAll = {
            id: "",
            name: "---All---"
          };
          this.productGroupList.splice(
            0,
            0,
            JSON.parse(JSON.stringify(findAll))
          );
        })
        .catch(err => console.log(err));
    },

    getMenuReportList() {
      this.showListLoading = true;
      let order = this.pagination.descending ? "desc" : "asc";
      menuReportService
        .getMenuReportList(
          this.queryParams,
          this.pagination.page,
          this.pagination.rowsPerPage,
          this.pagination.sortBy + "," + order
        )
        .then(res => {
          if (res.data) {
            this.menuReportList = res.data.menuReportList;
            this.totalRows = res.data.totalElements;
          }
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },
    getMenuReportSummary() {
      menuReportService
        .getMenuReportSummary(this.queryParams)
        .then(res => {
          if (res.data) {
            this.totalRetailSaleAmount = res.data.totalRetailSaleAmount;
            this.totalRetailSaleFocAmount = res.data.totalRetailSaleFocAmount;
            this.totalWholeSaleAmount = res.data.totalWholeSaleAmount;
            this.totalWholeSaleFocAmount = res.data.totalWholeSaleFocAmount;
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    printAllMenu(divName) {
      this.buttonLoading = true;
      menuReportService
        .getAllMenuReportList(this.clonequeryParams)
        .then(res => {
          if (res.data) {
            this.allMenuReportList = res.data.menuReportList;
          }
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          var printContents = document.getElementById(divName).innerHTML;
          var reprintWindow = window.open(
            "",
            "MsgWindow",
            "width=500,height=500"
          );
          reprintWindow.document.write(printContents);
          setTimeout(() => {
            reprintWindow.print();
            reprintWindow.close();
          }, 600);
          this.buttonLoading = false;
        });
    },
    clear() {
      this.queryParams.data = commonService.formatDate(
        new Date(),
        "YYYY-MM-DD"
      );
    },
    showDetailDialog(productSale) {
      this.productCode = productSale.productCode;
      this.productName = productSale.productName;
      this.detailQueryParams.fromDate = this.queryParams.fromDate;
      this.detailQueryParams.toDate = this.queryParams.toDate;
      this.detailQueryParams.saleType = productSale.saleType;
      this.detailQueryParams.shopName = productSale.shopName;
      this.detailQueryParams.productCode = productSale.productCode;
      this.detailQueryParams.factorUnitName = productSale.factorUnitName;
      this.detailQueryParams.unitPrice = productSale.unitPrice;
      this.detailQueryParams.issueNo = "";
      this.getMenuReportDetail().then(
        (this.detailDialogFlag = !this.detailDialogFlag)
      );
    },
    getMenuReportDetail() {
      return menuReportService
      .getMenuReportDetailList(this.detailQueryParams)
      .then((res) => {
        this.menuReportDetailList = res.data.menuReportDetailList;
        this.detailTotalRow = res.data.totalElements;
        this.totalSaleQty = res.data.totalSaleQty;
        this.totalSaleAmount = res.data.totalSaleAmount;
      })
      .catch((err) => {
        console.log(err);
      });
    },
    detailSearch() {
      this.detailQueryParams.page = this.detailPagination.page;
      this.detailQueryParams.size = this.detailPagination.rowsPerPage;
      this.getMenuReportDetail();
    },
    getActiveCurrency() {
      return currencyService.getCurrencyByStatus('ACTIVE')
      .then((res)=>{
        if(res.data){
          this.currencyList = res.data;
          let c = commonService.search("defaultCurrency",true,this.currencyList);
          if(c){
            this.queryParams.currencyId = c.id;
            this.currencyCode = c.code;
          }
        }
      })
      .catch((err)=>{
        console.log(err);
      });
    },
  }
};
</script>
